import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Client } from '@state/clients/client.model';
import { UiQuery } from '@state/ui/ui.query';
import { ClientService } from '@state/clients/client.service';
import { ClientQuery } from '@state/clients/client.query';

@Component({
    selector: 'app-clients-list',
    templateUrl: './clients-list.component.html',
    styleUrls: ['./clients-list.component.scss'],
    standalone: false
})
export class ClientsListComponent implements OnInit, OnDestroy {
    @Input() clients$: Observable<Client[]>;
    @Input() clientsCount: number;

    @Output() clientClick = new EventEmitter<Client>();

    infiniteScrollDisabled = true;
    loading$: Observable<boolean>;

    private infiniteScrollEvent: any;

    private clientsPaginationSubscription: Subscription;
    private paginationSubscription: Subscription;

    constructor(
        private clientQuery: ClientQuery,
        private clientService: ClientService,
        public uiQuery: UiQuery,
    ) {
        this.loading$ = uiQuery.selectLoading();
    }

    ngOnInit(): void {
        // Check if we need to show the infinite scroll
        this.clientQuery.selectIsLastPage().subscribe(isLastPage => {
            this.infiniteScrollDisabled = isLastPage;
        });
    }

    handleClick(client: Client): void {
        this.paginationSubscription?.unsubscribe();
        this.infiniteScrollEvent?.target?.complete();
        this.clientClick.emit(client);
    }

    loadMoreClients(event: any): void {
        this.infiniteScrollEvent = event;
        this.paginationSubscription = this.clientService.getClientsPagination(this.clientQuery.getCurrentPage() + 1)
            .subscribe(() => event.target.complete());
    }

    ngOnDestroy(): void {
        this.clientsPaginationSubscription?.unsubscribe();
    }
}
